import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import cn from 'classnames';
import ScrollWrapper from 'components/ScrollWrapper';
import { getCurrentDevice, isSmaller } from 'helpers/devices';
import VersionsToggler from './components/VersionsToggler';
import DeviceToggler from './components/DeviceToggler';
import Back from './components/Back';
import IFrame from './components/IFrame';
import { getDefaultVersion } from '../../fn/utils';
import { postScrollMessage, postScrollMessageStop } from './components/utils';

class Preview extends Component {
  constructor(props) {
    super(props);

    this.iframe = React.createRef();
  }

  state = {
    active: getDefaultVersion(this.props.template),
    device: getCurrentDevice(),
  };

  onClose = () => {
    this.props.onClose();
  };

  componentDidMount() {
    this.resizedDevice = getCurrentDevice();
    window.addEventListener('resize', this.onWindowResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize, false);
  }

  onWindowResize = () => {
    this.resizedDevice = getCurrentDevice();

    this.setState({
      device: isSmaller(this.resizedDevice, this.state.device)
        ? this.resizedDevice
        : this.state.device,
      recheckHeight: true,
    });
  };

  onChangeVersion = (version) => {
    if (this.state.active.id === version.id) return;

    this.setState({ active: version });
  };

  onChangeDevice = (device) => {
    this.setState({ device, recheckHeight: true });
  };

  onIFrameHeightChange = (height) => {
    this.setState({ recheckHeight: false }, () =>
      this.scroll.updateScroll(height)
    );
  };

  onScroll = (value) => {
    postScrollMessage(this.iframe, value);
  };

  onScrollStop = () => {
    postScrollMessageStop(this.iframe);
  };

  render() {
    const { active, device, recheckHeight } = this.state;
    const {
      template: { versions },
    } = this.props;

    const wrapperDeviceClass = cn(
      'template__preview',
      `wrapper-${
        isSmaller(this.resizedDevice, device) ? this.resizedDevice : device
      }`
    );

    return (
      <CSSTransition
        mountOnEnter
        timeout={0}
        appear
        classNames="templateFade"
        in
      >
        <div className="overlay">
          <div
            className={wrapperDeviceClass}
            ref={(node) => (this.container = node)}
          >
            <div className="template__preview-device">
              <div className="inner">
                <Back onClick={this.onClose} />

                <div className="inner__devices">
                  <DeviceToggler
                    active={device}
                    onChange={this.onChangeDevice}
                  />
                </div>
              </div>
            </div>

            <div className="template__preview-head">
              <div className="template__preview-mode">
                <VersionsToggler
                  active={active}
                  versions={versions}
                  onChange={this.onChangeVersion}
                />
              </div>
            </div>

            <div className="template__preview-body">
              <ScrollWrapper
                viewClassName="view"
                ref={(node) => (this.scroll = node)}
                onScroll={this.onScroll}
                onScrollStop={this.onScrollStop}
              >
                <IFrame
                  link={active.link}
                  onHeightChange={this.onIFrameHeightChange}
                  recheckHeight={recheckHeight}
                  key={active.link}
                  ref={this.iframe}
                />
              </ScrollWrapper>
            </div>
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default Preview;
